import clsx from 'clsx'
import React from 'react'
import {connect} from 'react-redux'
import {size, toArray} from 'lodash'
import {makeStyles} from 'external/material'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import {viewerGuard} from 'helpers/url'

const useStyles = makeStyles(createStyles)

const UploadedFiles = props => {
  const { fileProgress, uploadFile, retryUpload, deleteUpload, resetUploads, translate = a => a, downloadServer } = props
  const uploadedFileAmount = size(fileProgress)
  const classes = useStyles() 
  const contentLink = file => {
    return `${downloadServer}/${file.folder}/${file.file.name}`
  }

  return uploadedFileAmount > 0 ? (
    <div className={clsx(classes.wrapper)}>      
      {size(fileProgress)
        ? toArray(fileProgress).filter(f => !f.deleted)
          .map(file => { return (   
            <div key={file.id}>
              <AttachFileIcon />
              <a {...viewerGuard({href: contentLink(file), target: "_blank"})}>{file.file.name}</a>
            </div> 
          )})
        : null}
    </div>
  ) : null
}

const mapStateToProps = state => ({
  fileProgress: state.UploadFile.fileProgress,
})


export default connect(mapStateToProps)(UploadedFiles)


function createStyles(theme) {  
  return {
    root: {      
    },
    wrapper: {
      
    }
  }
}
